import * as jwt_decode from 'jwt-decode'
import { action, observable, computed } from 'mobx'
import { UserRoles } from '../Model/User'
import LocalizationStore from './LocalizationStore'

export interface IUserStore {
}

const accessToken = 'accessToken'
const tokenType = 'tokenType'
const idtoken = 'idtoken'

export default class UserStore implements IUserStore {
    @observable id: string

    @observable name: string

    @observable roles: Array<string> | string

    @observable translatedRoles: string

    @observable
    private isActive: boolean

    @computed
    get checkIsActive() {
        return this.isActive
    }

    private static _instance: UserStore

    private constructor() {
        this.init()
    }

    public static getInstance(): UserStore {
        return this._instance || (this._instance = new this())
    }

    public init(): void {
        let idToken = window.localStorage.getItem('idToken')
        if (!idToken) {
            idToken = window.localStorage.getItem('idToken')
        }
        window.localStorage.setItem('idToken', idToken + '')

        if (idToken && idToken.length) {
            try {
                let decoded = jwt_decode(idToken + '') // just pretty hack for string | null
                this.id = decoded['sub']
                this.roles = decoded['role']
                this.roles = typeof this.roles === 'string' ? [this.roles] : this.roles
                this.name = decoded['name']
                this.translatedRoles = this.getTranslatedRoles()
            } catch (error) {
                console.info(error)
            }
        }
    }

    @action.bound
    setData(
        type: string,
        access: string,
        id: string,
        expires: string,
        refresh: string
    ): void {
        let lang = window.localStorage.getItem('lang')
        window.localStorage.clear()
        window.localStorage.setItem('lang', lang ? lang : 'AZ')
        window.localStorage.setItem('tokenType', type)
        window.localStorage.setItem('accessToken', access)
        window.localStorage.setItem('idToken', id)
        window.localStorage.setItem('refreshToken', refresh)
        window.localStorage.setItem('expiresIn', expires)

        this.init()
    }

    @action.bound
    updateAcceptToken(
        type: string,
        token: string
    ) {
        window.localStorage.setItem('tokenType', type)
        window.localStorage.setItem('accessToken', token)
    }

    getTranslatedRoles(): string {
        const ls = LocalizationStore.getInstance()

        let translatedRoles: Array<String> = []

        if (typeof this.roles !== 'string') {
            for (let i = 0; i < this.roles.length; ++i) {
                translatedRoles.push(ls.t(this.roles[i]))
            }
            return translatedRoles.join(', ')
        }
        return ls.t(this.roles)
    }

    killSession() {

        let lang = window.localStorage.getItem('lang')
        window.localStorage.clear()
        window.localStorage.setItem('lang', lang ? lang : 'AZ')
        this.name = ''
        this.roles = []
        this.translatedRoles = ''
    }

    get checkSession() {
        let retVal = !!window.localStorage.getItem('accessToken')
        // if (!retVal) {
        //     // this.init()
        //     retVal = !!window.localStorage.getItem('accessToken')
        // }
        return retVal
    }

    get checkAdmin(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.Administrator)
        }
        return false
    }

    get checkSuperAdmin(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.SuperAdmin)
        }
        return false
    }

    get checkCreditExpert(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CreditExpert)
        }
        return false
    }

    get checkCreditConsultant(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CreditConsultant)
        }
        return false
    }

    get checkCollector(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.Collector)
        }
        return false
    }

    get checkLawyer(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.Lawyer)
        }
        return false
    }

    get checkCaller(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.Caller)
        }
        return false
    }

    get checkCollectionGroupAdministrator(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CollectionGroupAdministrator)
        }
        return false
    }

    get checkCreditGroupAdministrator(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CreditGroupAdministrator)
        }
        return false
    }

    get checkLogisticsAgent(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.LogisticsAgent)
        }
        return false
    }
    
    get checkCashier(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.Cashier)
        }
        return false
    }

    get checkCashierAdmin(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CashierAdmin)
        }
        return false
    }
    
    get checkCatalogProductAdministrator(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.CatalogProductAdministrator)
        }
        return false
    }

    get checkHardCaller(): boolean {
        if (this.roles) {
            return -1 !== this.roles.indexOf(UserRoles.HardCaller)
        }
        return false
    }

    get accessToken() {
        return window.localStorage.getItem(accessToken)
    }

    get tokenType() {
        return window.localStorage.getItem(tokenType)
    }

    get idToken() {
        return window.localStorage.getItem(idtoken)
    }

    getAuthHeader() {
        if (this.tokenType && this.accessToken) {
            return {
                'Authorization': `${this.tokenType} ${this.accessToken}`
            }
        }
        return null
    }

    getPostFormAuthHeader() {
        if (this.tokenType && this.accessToken) {
            return {
                'Content-Type': 'application/json',
                'Authorization': this.tokenType + ' ' + this.accessToken
            }
        }
        return null
    }

    getPostMultipartFormDataAuthHeader() {
        if (this.tokenType && this.accessToken) {
            return {
                'Content-Type':
                    'multipart/form-data; boundary=----------------------------247947f6cc02',
                'Authorization': this.tokenType + ' ' + this.accessToken,
                'type': 'formData',
                'enctype': 'multipart/form-data'
            }
        }
        return null
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/UserStore.tsx